import { render } from "./SelectEditorCmp.vue?vue&type=template&id=61c6fda0"
import script from "./SelectEditorCmp.vue?vue&type=script&lang=js"
export * from "./SelectEditorCmp.vue?vue&type=script&lang=js"

import "./SelectEditorCmp.vue?vue&type=style&index=0&id=61c6fda0&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__